/* NUTRI Shopify theme — interactions (chrome is rendered by Liquid sections) */
(function () {
  // ---------- mobile menu ----------
  var burger = document.querySelector(".burger");
  function setMenu(open) {
    document.body.classList.toggle("nav-open", open);
    document.documentElement.classList.toggle("nav-open", open);
    if (burger) burger.setAttribute("aria-expanded", open ? "true" : "false");
  }
  if (burger) {
    burger.addEventListener("click", function () {
      setMenu(!document.body.classList.contains("nav-open"));
    });
  }
  Array.prototype.forEach.call(document.querySelectorAll(".nav-menu a"), function (a) {
    a.addEventListener("click", function () { setMenu(false); });
  });

  // ---------- sticky header ----------
  var header = document.querySelector(".site-header");
  function onScroll() {
    if (!header) return;
    if (window.scrollY > 20) header.classList.add("solid"); else header.classList.remove("solid");
  }
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  // ---------- scroll reveal ----------
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    Array.prototype.forEach.call(document.querySelectorAll(".reveal"), function (el) { io.observe(el); });
  } else {
    Array.prototype.forEach.call(document.querySelectorAll(".reveal"), function (el) { el.classList.add("in"); });
  }

  // ---------- flavor accent theming ----------
  var THEME = {
    orange: ["#4a90d9", "#5bbef0"],
    pine:   ["#8bbe1d", "#aacd3a"],
    mars:   ["#e8552d", "#ff7a18"]
  };
  Array.prototype.forEach.call(document.querySelectorAll("[data-flavor]"), function (el) {
    function set() {
      var th = THEME[el.getAttribute("data-flavor")];
      if (th) { document.documentElement.style.setProperty("--accent", th[0]); document.documentElement.style.setProperty("--accent-2", th[1]); }
    }
    el.addEventListener("mouseenter", set);
    el.addEventListener("click", set);
  });

  // ---------- hero cans tilt ----------
  var cans = document.querySelector(".hero-cans");
  if (cans && window.matchMedia("(pointer:fine)").matches &&
      !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    cans.addEventListener("mousemove", function (e) {
      var r = cans.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      cans.style.transform = "rotateX(" + (-y * 7).toFixed(2) + "deg) rotateY(" + (x * 9).toFixed(2) + "deg)";
    });
    cans.addEventListener("mouseleave", function () { cans.style.transform = ""; });
  }

  // ---------- entry gate (rendered by the gate section on the home template) ----------
  var gate = document.getElementById("nutri-gate");
  if (gate) {
    var seen = false;
    try { seen = !!sessionStorage.getItem("nutri-gate-seen"); } catch (e) {}
    try { if (document.referrer && new URL(document.referrer).host === location.host) seen = true; } catch (e) {}
    if (seen) {
      gate.remove();
    } else {
      gate.hidden = false;
      document.documentElement.classList.add("gate-open");
      document.body.classList.add("gate-open");
      function done() {
        try { sessionStorage.setItem("nutri-gate-seen", "1"); } catch (e) {}
        document.documentElement.classList.remove("gate-open");
        document.body.classList.remove("gate-open");
      }
      var d = document.getElementById("gate-drink");
      var f = document.getElementById("gate-frozen");
      if (d) d.addEventListener("click", function () { done(); gate.remove(); });
      if (f) f.addEventListener("click", function (ev) { done(); });
    }
  }

  // ---------- AJAX add to cart ----------
  Array.prototype.forEach.call(document.querySelectorAll("form[data-ajax-cart]"), function (form) {
    form.addEventListener("submit", function (ev) {
      ev.preventDefault();
      var btn = form.querySelector("[type=submit]");
      var orig = btn ? btn.textContent : "";
      fetch("/cart/add.js", { method: "POST", body: new FormData(form), headers: { "Accept": "application/json" } })
        .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
        .then(function () { return fetch("/cart.js").then(function (r) { return r.json(); }); })
        .then(function (cart) {
          Array.prototype.forEach.call(document.querySelectorAll(".cart-count"), function (c) { c.textContent = cart.item_count; });
          if (btn) { btn.textContent = btn.getAttribute("data-added-label") || "✓"; setTimeout(function () { btn.textContent = orig; }, 1600); }
        })
        .catch(function () { if (btn) btn.textContent = orig; });
    });
  });

  // ---------- rotating IG feed ----------
  var feed = document.querySelector("[data-ig-rotate]");
  if (feed && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    var pool = [];
    try { pool = JSON.parse(feed.getAttribute("data-ig-rotate")) || []; } catch (e) {}
    var tiles = Array.prototype.slice.call(feed.querySelectorAll(".ig-tile img"));
    if (pool.length && tiles.length) {
      pool.forEach(function (src) { new Image().src = src; });
      var next = tiles.length, turn = 0;
      setInterval(function () {
        var img = tiles[turn % tiles.length];
        var src = pool[next % pool.length];
        turn++; next++;
        if (img.getAttribute("src") === src) src = pool[(next++) % pool.length];
        img.classList.add("fading");
        setTimeout(function () {
          img.onload = function () { img.classList.remove("fading"); img.onload = null; };
          img.src = src;
        }, 560);
      }, 3200);
    }
  }
})();
